import { Button, Flex, Popconfirm } from "antd";
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Link } from "react-router-dom"

export default function ContentTable({ elements, useType, type, deleteEntry }) {
    function stripHtml(html) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    }

    const truncateStyle = {
      maxWidth: "300px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis"
    }

    return (
      <table className="table" style={{marginTop: "10px"}}>
        <thead>
          <tr>
            <th>Názov</th>
            {useType && <th>Typ</th>}
            <th>Autor</th>
            <th>Publikované</th>
            <th>Naposledy upravené</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {elements.map(item=> (
            <tr key={item.id}>
              <td style={truncateStyle}>{item.title ? item.title : stripHtml(item.content)}</td>
              {useType && <td>{item.type_title}</td>}
              <td>{item.firstname + " " + item.lastname}</td>
              <td>{item.status}</td>
              <td>{item.updated}</td>
              <td>
                <Flex justify="space-evenly">
                  <Link to={`/admin/content/${type == null ? item.type : type}/edit/${item.id}`}>
                    <Button filled>
                        <EditOutlined></EditOutlined>
                    </Button>
                  </Link>
                  <Popconfirm
                    title="Delete entry"
                    description="Delete the entry?"
                    onConfirm={() => {deleteEntry(type == null ? item.type : type, item.id)}}
                    onCancel={() => {}}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button danger><DeleteOutlined></DeleteOutlined></Button>
                  </Popconfirm>
                </Flex>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
}